function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import { Button, ControlLabel } from 'react-bootstrap';
import React, { Component } from 'react';
import Dropzone from 'react-dropzone';
import PropTypes from 'prop-types';

import './Dropzone.css';

var _Dropzone = function (_Component) {
  _inherits(_Dropzone, _Component);

  function _Dropzone() {
    var _temp, _this, _ret;

    _classCallCheck(this, _Dropzone);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.files = function () {
      return _this.context.form.get(_this.props.name) || [];
    }, _this.handleClear = function () {
      _this.context.form.set(_this.props.name, []);
    }, _this.handleDrop = function (s) {
      _this.context.form.set(_this.props.name, s);
    }, _this.description = function () {
      var lines = _this.files().map(function (file, i) {
        return React.createElement(
          'p',
          { key: file.name },
          file.name,
          ' (',
          file.size,
          ' bytes)'
        );
      });

      if (lines.length === 0) {
        lines.push(React.createElement(
          'p',
          { key: 'info' },
          'Drag a file here or click to select'
        ));
      }

      return React.createElement(
        'div',
        { className: 'Dropzone-Text' },
        lines
      );
    }, _this.render = function () {
      return React.createElement(
        'div',
        null,
        _this.props.label && React.createElement(
          ControlLabel,
          null,
          _this.props.label
        ),
        React.createElement(
          Dropzone,
          {
            accept: _this.props.accept,
            acceptClassName: 'Dropzone-Accept',
            activeClassName: 'Dropzone-Active',
            className: 'Dropzone',
            multiple: _this.props.multiple,
            rejectClassName: 'Dropzone-Reject',
            onDrop: _this.handleDrop
          },
          _this.description()
        ),
        _this.files().length > 0 && React.createElement(
          Button,
          { bsSize: 'large', bsStyle: 'danger', className: 'Dropzone-Clear',
            onClick: _this.handleClear },
          'Clear'
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return _Dropzone;
}(Component);

_Dropzone.contextTypes = {
  form: PropTypes.object.isRequired
};

_Dropzone.defaultProps = {
  multiple: true
};

_Dropzone.propTypes = process.env.NODE_ENV !== "production" ? {
  accept: PropTypes.string,
  label: PropTypes.string,
  multiple: PropTypes.bool,
  name: PropTypes.string.isRequired
} : {};

export default _Dropzone;


//////////////////
// WEBPACK FOOTER
// ./node_modules/bodyspec-form-builder/es/Fields/Dropzone.js
// module id = 688
// module chunks = 0